export default __webpack_public_path__ + "static/media/collapse.3092a716.svg";